module.exports = __webpack_public_path__ + "static/media/dualMsgActive.90c57f1c.svg";